// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const label = "PieChartPlaceholder__label__JC401 font-faces__sansSemibold__K6NQF font-faces__sans__uCf65";
export const medium = "500";
export const pieChartPlaceholder = "PieChartPlaceholder__pieChartPlaceholder__7sR-Q";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";